import * as React from "react";
import { Col, Row, Image, Button } from "react-bootstrap";

interface Props {
	img: string;
	title: string;
	text: string;
	backgroundImage1: string;
	backgroundImage2: string;
	backgroundImage3: string;
	redux?: boolean
}

export default function ProductShowcase(props: Props) {
	return (
		<div className="productshowcase">
			<Row>
				<Col className="showcase-image-col" >
					<Image className="showcase-image" src={props.backgroundImage1} />
				</Col>
				<Col className="showcase-image-col d-none d-lg-block">
					<Image className="showcase-image" src={props.backgroundImage2} />
				</Col>
				<Col className="showcase-image-col ">
					<Image className="showcase-image" src={props.backgroundImage3} />
				</Col>
			</Row>
			<Row className={`showcase-preview-image-row ${props.redux ? "REDUX" : ""}`} >
				<Col >
					<Image
						className="showcase-preview-image"
						src={props.img}
						alt={`Image of ${props.title}`}
					/>
				</Col>
				<div className="showcase-text">
					<Image
						src={props.title}
						alt="Protect"
					/>
					<p>
						{props.text}
					</p>
				</div>
			</Row>
		</div>
	);
}
